import { render, staticRenderFns } from "./Comment-block.vue?vue&type=template&id=42750354&scoped=true&"
import script from "./Comment-block.vue?vue&type=script&lang=ts&"
export * from "./Comment-block.vue?vue&type=script&lang=ts&"
import style0 from "./Comment-block.vue?vue&type=style&index=0&id=42750354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42750354",
  null
  
)

export default component.exports